import { useMemo } from "react";
import { useInfiniteQuery } from "@tanstack/react-query";
import api from "../../../services/api";

interface ExtractedFilesCounts {
  goodware: string;
  malicious: string;
  suspicious: string;
  unknown: string;
}
const useInitExtractedFilesData = (
  sampleSourceSha1?: string,
  relationshipID?: string,
  extractedFilesCounts?: ExtractedFilesCounts
) => {
  const {
    data: extractedFilesData,
    fetchNextPage: loadMoreExtractedFiles,
    isFetching
  } = useInfiniteQuery({
    queryKey: ["extractedFilesKey", sampleSourceSha1, relationshipID],
    queryFn: ({ pageParam }) =>
      api.getExtractedFiles({
        hashValue: sampleSourceSha1,
        extractedFilesQP: {
          view_type: "FLAT",
          page_size: 20,
          page: pageParam,
          relationship: relationshipID,
          ordering: "-child__threat_status,-child__local_first_seen"
        }
      }),
    getNextPageParam: (lastPage, pages) => {
      if (lastPage.data.next) {
        return pages.length + 1;
      }
      return undefined;
    },
    select: ({ pages }) => {
      const [lastPage] = pages.slice(-1);
      return lastPage?.data?.results;
    },
    enabled: Boolean(sampleSourceSha1),
    initialPageParam: 1,
    refetchOnMount: false,
    refetchOnWindowFocus: false
  });

  const extractedFilesTotalCount = useMemo(
    () =>
      Object.values(extractedFilesCounts || []).reduce(
        (acc, value) => acc + parseInt(value, 10),
        0
      ),
    [extractedFilesCounts]
  );
  return {
    data: {
      extractedFilesData
    },
    counts: {
      extractedFilesTotalCount
    },
    actions: { loadMoreExtractedFiles },
    isFetching
  };
};

export default useInitExtractedFilesData;
